export type PlatformOwnerResource = {
	type:
		| 'applications'
		| 'gcpProjects'
		| 'clusters'
		| 'accounts'
		| 'rhocpTenants'
	id: string
}

const getPlatformOwnerPermissions = ({ type, id }: PlatformOwnerResource): string[] => [
	`${type}:${id}:read`,
	`${type}:${id}:update`,
	`${type}:${id}:approve`,
	'tags:PlatformOwner:*',
	'tags:*:update'
]

export default getPlatformOwnerPermissions